import { ILogEntry } from '../log-entry.interface';

export interface ILogRawEntry extends ILogEntry {
  sessionId: number;
}